import React from 'react';

import { ModalBase, ModalBaseProps } from '@tanium/react-modal-base';

import ModalContainer, { ModalContainerProps, ModalSize } from './ModalContainer';
import ModalContent, { Props as ModalContentProps } from './ModalContent';

export interface Props extends ModalBaseProps, ModalContentProps {
  /**
   * A custom container used to wrap the standard modal content. If not specified, the standard
   * `ModalContainer` is used.
   */
  container?: React.ComponentType<ModalContainerProps>;
  /**
   * The size of the modal container. May be `sm`, `md`, or `lg`; for the default container,
   * defaults to `md`. If you specify a custom `container`, this prop is passed to the custom
   * container.
   */
  size?: ModalSize;
}

/**
 * A styled modal with optional generic header and footer.
 */
const Modal = ({
  isOpen,
  onRequestClose,
  size,
  header,
  subheader,
  footer,
  children,
  container: Container = ModalContainer,
}: Props) => (
  <ModalBase isOpen={isOpen} onRequestClose={onRequestClose}>
    <Container size={size}>
      <ModalContent header={header} subheader={subheader} footer={footer}>
        {children}
      </ModalContent>
    </Container>
  </ModalBase>
);

export default Modal;
